import { render, staticRenderFns } from "./Automatic.vue?vue&type=template&id=802aac82&scoped=true&"
import script from "./Automatic.vue?vue&type=script&lang=js&"
export * from "./Automatic.vue?vue&type=script&lang=js&"
import style0 from "./Automatic.vue?vue&type=style&index=0&id=802aac82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802aac82",
  null
  
)

export default component.exports